var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddIconContent(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.25,
    y: 0.5,
    width: 25,
    height: 25,
    rx: 4.5,
    fill: "white",
    stroke: "#D7D7D7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3345_4014)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3345_4014)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.125 12.125H14.875V6.875C14.875 6.39175 14.4832 6 14 6C13.5168 6 13.125 6.39175 13.125 6.875V12.125H7.875C7.39175 12.125 7 12.5168 7 13C7 13.4832 7.39175 13.875 7.875 13.875H13.125V19.125C13.125 19.6082 13.5168 20 14 20C14.4832 20 14.875 19.6082 14.875 19.125V13.875H20.125C20.6082 13.875 21 13.4832 21 13C21 12.5168 20.6082 12.125 20.125 12.125Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3345_4014"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(7 6)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3345_4014"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(7 6)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIconContent);
export default __webpack_public_path__ + "static/media/addIconContent.73700c921b4190796fbf0e06f31464b9.svg";
export { ForwardRef as ReactComponent };